import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

interface MapState {
}

const initialState: MapState = {
};

export const mapSlice = createSlice({
	name: 'map',
	initialState,
	reducers: {
		addFeature: (state) => {
		}
	}
});


export default mapSlice.reducer;
